import { useState, type ReactNode } from 'react'

interface Props {
  label?: string
  children: ReactNode
  open?: boolean           // controlled: 外から open 状態を制御
  onToggle?: () => void    // controlled: トグル callback
}

export function FilterBar({ label = 'フィルター', children, open: controlledOpen, onToggle }: Props) {
  const [internalOpen, setInternalOpen] = useState(false)
  const isOpen = controlledOpen !== undefined ? controlledOpen : internalOpen
  const toggle = onToggle ?? (() => setInternalOpen(o => !o))

  return (
    <div className="flex-shrink-0 border-b border-border-subtle bg-bg-surface">
      <button
        type="button"
        onClick={toggle}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-text-subtle hover:text-text-base active:bg-bg-overlay"
      >
        <span aria-hidden="true">{isOpen ? '▲' : '▼'}</span>
        <span>{label}</span>
      </button>
      {isOpen && (
        <div className="px-4 pb-4 overflow-y-auto max-h-[60vh]">
          {children}
        </div>
      )}
    </div>
  )
}
